/* import __COLOCATED_TEMPLATE__ from './seller-main-nav.hbs'; */
import Component from '@glimmer/component';
import constants from 'sh-www/constants';
import clsx from 'clsx';

const {
  SELLER_ROUTE_PARENT_NAME__PRIMARY_ROUTE_MAP,
  SELLER_ROUTE_PARENT_NAMES,
} = constants;

const route = (name) => SELLER_ROUTE_PARENT_NAME__PRIMARY_ROUTE_MAP[name].route;

class SellerMainNavComponent extends Component {
  get postingsRoute() {
    return route(SELLER_ROUTE_PARENT_NAMES.POSTINGS);
  }

  get postingsClasses() {
    return this.getClassesForRoute(SELLER_ROUTE_PARENT_NAMES.POSTINGS);
  }

  get projectsRoute() {
    return route(SELLER_ROUTE_PARENT_NAMES.PROJECTS);
  }

  get projectsClasses() {
    return this.getClassesForRoute(SELLER_ROUTE_PARENT_NAMES.PROJECTS);
  }

  get messagesRoute() {
    return route(SELLER_ROUTE_PARENT_NAMES.MESSAGES);
  }

  get messagesClasses() {
    return this.getClassesForRoute(SELLER_ROUTE_PARENT_NAMES.MESSAGES);
  }

  get reportsRoute() {
    return route(SELLER_ROUTE_PARENT_NAMES.REPORTS);
  }

  get reportsClasses() {
    return this.getClassesForRoute(SELLER_ROUTE_PARENT_NAMES.REPORTS);
  }

  getClassesForRoute(name) {
    return clsx(
      'basic-text-link',
      name === this.args.headerRouteParentName && 'parent-active',
    );
  }
}

export default SellerMainNavComponent;
